// extracted by css-extract-rspack-plugin
export default {"unorderedList":"content-editor-plugin-unordered-list-UnorderedList-unorderedList-d483a11f"};